import { AnimationBaseController, ResourceItem, ResourceItemType, SimpleBaseController } from "@denishussar/html5-game-engine";


//todo: check interactivity of hidden children in view

interface ViewObject {
    key: string;
    controller: SimpleBaseController | AnimationBaseController;
}

export class ViewManager {

    protected history: ViewObject[] = [];
    protected currentView: ViewObject | null = null;
    protected preloaded: string[] = [];

    constructor(
        protected view: SimpleBaseController | AnimationBaseController,
    ) {
        
    }

    preloadBitmaps(key: string, json: {Bitmaps: {name:string, src:string}[]}) {
        const resources = [];
        json.Bitmaps.forEach(bitmap=>{
            resources.push(new ResourceItem(key+bitmap.name, json));
        })
        this.view.resourcesLoader.load(key+"json", resources, ()=>{
            this.preloaded.push(key);
        }, this.view);
    }

    /**
     * adds a controller to view pool for showing info
     * @param key an unique key for view to interact with
     * @param controller a class extends engine controller classes
     * @param options an object which represents the controllers options
     * @param model the controller model
     * @returns 
     */
    async addView2Pool(
        key: string,
        controller: any,
        options: object,
        model: any
    ): Promise<void> {

        return this.view.addChildControllerAsync({
            controller: controller,
            options,
            model
        }, 
        // !(this.preloaded.filter(k=>k==key).length > 0), 
        false,
        key)
            .then((controller) => {
                controller.visible = false;
                controller.display.interactiveChildren = false;
            })
    }

    removeViewFromPool(key: string) {
        this.history = this.history.filter((m) => m.key != key);
        if (this.currentView.key === key) this.currentView = null;
        this.view.removeChildControllerByName(key);
    }

    show(key: string) {
        if (this.view.$childControllers.get(key)) {
            //show modal
            if (this.currentView) {
                this.history.push(this.currentView)
                //this.currentView.controller.visible = false;
                //also will work if you dont hide modal
                this.currentView.controller.display.interactiveChildren = false;
            }

            this.currentView = { key, controller: this.view.$childControllers.get(key) };
            this.currentView.controller.visible = true;
            this.currentView.controller.display.interactiveChildren = true;
        }
    }

    hide(key: string = this.currentView ? this.currentView.key : undefined) {
        if (this.currentView && this.currentView.key === key) {
            this.currentView.controller.visible = false;
            this.currentView.controller.display.interactiveChildren = false;
            this.currentView = null;

            if (this.history.length) {
                this.currentView = this.history.pop();
                this.currentView.controller.display.interactiveChildren = true;
                //this.show(this.history.pop().key);
            }

        }
        else {
            this.history = this.history.filter(m => m.key != key);
        }

    }

}
